import React, { useEffect, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/* import element from component folder */
import Select from '../../components/select';

/* import function from store folder */
import { resetModel } from '../../store/components/modelSlice';

/* import fetch function */
import { GiveMemberPoint } from "../../services/member";

const GivePoints = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    const [point, setPoint] = useState(0);
    const { data } = useSelector(state => state.model);
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }, point}) => {
        const _source = Object.apply({}, source);

        delete error[name];
        _source.epId = value;
        _source.point = point;
        
        setError(error);
        setPoint(point);
        setSource(_source);
    };

    const submitHandler = event => {
        event.preventDefault();
        const isValidate = validate();

        if (isValidate) {
            GiveMemberPoint({mId: data.mId, source: source})
            .then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                }
            })
        }
    };

    const validate = () => {
        const checkLists = ['epId'];
        const _errors = {};

        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    return (
        <Modal show={ true } centered>
            <Modal.Header>Give Points</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label'>Member Email</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='email' value={ data.email } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Member Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='name' type='name' value={ `${data.firstName} ${data.lastName}` } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Event</div>
                        <span className='semicolon'>：</span>
                        <Select name='epId' select_all={ false } shadow={ false } required={error.epId} changHandle={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Give Points</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='point' value={ point } disabled />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default GivePoints;